import { useState } from "react";
import { toast } from "sonner";
import { AtSign } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Panel } from "@/components/core/AppLayout";

export const UsernameForm = () => {
  const { user, setUser } = useAuth();
  const [username, setUsername] = useState(user.username || "");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const r = await api.patch("/auth/me", { username });
      setUser(r.data);
      setUsername(r.data.username || "");
      toast.success("Username aggiornato");
    } catch (err) { toast.error(errMsg(err)); }
    finally { setSaving(false); }
  };

  return (
    <Panel className="p-8 core-rise core-delay-3 max-w-5xl mt-6">
      <h3 className="font-display text-xl font-extrabold text-[#0A1128] flex items-center gap-2 mb-2"><AtSign className="h-5 w-5 text-[#E8173A]" />Username</h3>
      <p className="text-sm text-slate-500 mb-5">Puoi accedere con l'email oppure con lo username. Lascia vuoto per rimuoverlo.</p>
      <form onSubmit={submit} className="flex items-end gap-3" data-testid="username-form">
        <div className="space-y-1.5 flex-1 max-w-sm">
          <Label className="text-xs font-bold uppercase tracking-wider text-slate-500">Username</Label>
          <Input value={username} onChange={(e) => setUsername(e.target.value)} placeholder="es. nome.cognome" className="rounded-xl h-11" data-testid="profile-username-input" />
        </div>
        <Button type="submit" disabled={saving} className="rounded-full bg-[#0A1128] hover:bg-[#E8173A] px-6 h-11 font-bold" data-testid="profile-username-submit">{saving ? "Salvataggio..." : "Salva username"}</Button>
      </form>
    </Panel>
  );
};
